import React, {useState, useEffect} from "react";
import {SetMetaData} from './../../helper/page-title';
import ValidationHelper from "../../helper/validation";
import {post_api_call,
        error_api_call,
        get_api_call
      } from './../../actions/action-creators/common';
import { alertResponseMessage } from "../../actions/action-creators/response";
//Modal
import FormDataAff from "../../data/formData/affiliate/settings";
import { LoaderMedium } from '../../components/loader';
import MasterForm  from '../../components/form/master';
const {
    fieldValuesComm,
    fieldValidationComm,
    fieldAffComm,
    optionComm
} = FormDataAff;

function AffiliateSettings(props){
    SetMetaData("Manage Affiliate Settings", "", "");
    const [isLoading, setIsLoading] = useState(true);
    const [errorData, setErrorData] = useState({comm: []});
    const [formCommData, setCommFormData] = useState({...fieldValuesComm});
    const [isProcess, setIsProcess] = useState({comm: false});
    // const [dropdownOpt, setDropdownOpt] = useState({comm: [optionComm]});

    const fetchCommData = async() => {
      try{
        const apiData = await get_api_call('affiliate/settings', {});
        if(apiData.status === 200){
            var data = apiData.data;
            data['commission'] = {id: data.commission, label: `${data.commission}%`};
            setCommFormData(data);
            setIsLoading(false);
        }
      }catch(e){
            error_api_call({error: `admin|screen|affiliate|settings|fetchCommData|${e}`});
      }
    }
    useEffect(() => {
        // var commOppData = [{id: 0, label: '0%'}];
        // for (let i = 1; i <= 60; i++) {
        //     if (i % 5 === 0) {
        //         commOppData.push({id: i, label: `${i}%`});
        //     }
        // }
        // setDropdownOpt({...dropdownOpt, comm: commOppData});
        fetchCommData();
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //Update Input
    const updateInput = (form_type, state_var_type, input_type, field, value, field_type="", form_field="", index=0) => {
        try{
            if(errorData[form_type].length){
                setErrorData({...errorData, [form_type]: []});
            }

            if(field === 'fixed_cost'){
                value = value.replace(/[^0-9]/g, '');
            }else if(input_type === 'input'
                || input_type === 'textarea'
            ){
                // value = value.replace(/ /g, '');
                value = value.trimStart();
            }
            var updatedFormDetails = state_var_type === 'array' 
                                ? [] 
                                : state_var_type === 'object'
                                    ? {}
                                    : '';
            if(field_type === 'array'){
                const fieldData = {...formCommData};
                fieldData[form_field][index][field] = value;
                updatedFormDetails = {...fieldData};
                // setCommFormData({...fieldData});
            }else{
                updatedFormDetails = {...formCommData};
                updatedFormDetails[field] = value;
            }
            if(form_type === 'comm'){
                setCommFormData(updatedFormDetails);
            }
        }catch(e){
            console.log(e)
        }
    }
    //Submit Details
    const updateSettings = async(e, form_type='') => {
      try{
          e.preventDefault();
          setErrorData({...errorData, [form_type]: []});
          setIsProcess({...isProcess, [form_type]: true});
          var errorDetails = {...errorData};
          var apiFormData = new FormData();
          //Validation
          var validation = [];
          var inputData = {};
          switch (form_type) {
              case 'comm':
                inputData = {...formCommData};
                break;
              default:
          }
          validation = ValidationHelper.validation(inputData, fieldValidationComm).error;
          if(validation.length){
            errorDetails[form_type] = validation;
          }
          
          if(errorDetails[form_type].length > 0){
              setErrorData({...errorData, [form_type]: errorDetails[form_type]});
              setIsProcess({...isProcess, [form_type]: false});
              // setBtnDisabled({...isBtnDisabled, [form_type]: true});
          }else{
              //Send Data to Server
              var api = 'create';
              if(form_type === 'comm'){
                api = 'affiliate/settings';
                apiFormData.append('commission', inputData.commission.id);
                apiFormData.append('fixed_cost', inputData.fixed_cost);
              }
              const updateOppor = await post_api_call(`${api}`, apiFormData);
              if(updateOppor.status === 200){
                  alertResponseMessage({alert_type: 1, message: "Information Updated Successfully"});
                  // setBtnDisabled({...isBtnDisabled, [form_type]: true});
                  setIsProcess({...isProcess, [form_type]: false});
                //   setIsLoading(true);
              }else{
                  setIsProcess({...isProcess, [form_type]: false});
                  if(typeof updateOppor.message !== "undefined"){
                      setErrorData({...errorData, [form_type]: [updateOppor.message]});
                  }
              }
          }
          
      }catch(e){
          console.log(e);
          setErrorData({...errorData, [form_type]: ['Something Went Wrong, Please Try After Some Time']});
          setIsProcess({...isProcess, [form_type]: false});
          error_api_call({error: `admin|screens|affiliate|settings|${e}`});
      }
    }

    return (
        isLoading
        ?
            <LoaderMedium />
        :
        <>
        <div className="row">
            <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
                <div className="card-body border border-1 border-success p-4 mod-custom">
                   <MasterForm
                        formType={'comm'}
                        data={formCommData}
                        title={"title"}
                        _errorData={{...errorData}}
                        _isProcess={{...isProcess}}
                        // _isBtnDisabled={{...isBtnDisabled}}
                        _updateInput= {(form_type, variable_type, input_type, field, value) => updateInput(form_type, variable_type, input_type, field, value)}
                        _submitForm={(e, form_type) => updateSettings(e, form_type)}
                        _formData={[{form_type: 'comm', label: "Settings", fields: [...fieldAffComm]}]}
                        selectOptions={{commission:
                                        {value: 'id',
                                        label: 'label',
                                        data: [...optionComm],
                                        }
                                    }}
                    />
                </div>
            </div>
            </div>
        </div>
        </>
    )    
}

export default AffiliateSettings;